import React from "react";
import { formatCurrency } from "~/utils";

export default function RowAmount({ total }: { total: number }) {
  return <span>{formatCurrency(total)}</span>;
}
